(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["45R-dropdown-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    document.querySelectorAll('.fake-select').forEach((select) => {
      const checkbox = select.querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked && !select.contains(e.target)) {
        checkbox.checked = false;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
